exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-logo .lbp-logo-mark:before {\n  width: 6px;\n  height: 2px;\n  content: '';\n  -webkit-transition: background-color .25s ease;\n  -o-transition: background-color .25s ease;\n  transition: background-color .25s ease;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  position: absolute;\n  background-color: #ffffff;\n  top: 0;\n  left: 50%;\n}\n@media screen and (max-width: 1124px) {\n.site-header .main-logo {\n    font-size: 0.6875rem;\n    line-height: 0.75rem;\n}\n}\n", ""]);

// exports
